import { CommonModule } from '@angular/common';
import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { DisplayType, TypographyComponent, TypographyVariant } from '../typography/typography.component';

/**
 * Defines the available variants for typography.
 */
export type ColorVariant =
  | 'primary'
  | 'secondary';

/**
 * Defines the valid target values for links.
 */
export type LinkTarget = '_self' | '_blank' | '_parent' | '_top';

@Component({
  selector: 'hyperkit-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent], // Import RouterLink here
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkComponent {
  @Input() href = ''; // External link
  @Input() target: LinkTarget = '_self'; // Restrict to valid target values
  @Input() variant: TypographyVariant = 'h1';
  @Input() color: ColorVariant = 'primary';
  @Input() underline: 'always' | 'hover' | 'none' = 'hover';
  @Input() rel: 'noopener' | 'noreferrer' | 'none' = 'noopener';
  @Input() ariaLabel = '';
  @Input() text = ''; // Text to display inside the link
  @Input() display: DisplayType = 'block'; // Disable the link

  @HostBinding('attr.target') get hostTarget() {
    return this.target;
  }

  @HostBinding('attr.rel') get hostRel() {
    // Apply rel attribute only when target is "_blank" for security purposes
    return this.target === '_blank' ? this.rel : '';
  }

  // Determine if the link is external (i.e., if href is provided)
  get isExternalLink(): boolean {
    return !!this.href;
  }
}